<template>
  <div
    class="pos-page"
    tabindex="-1"
    @keydown.ctrl.enter.exact.prevent="onConfirmShortcut"
    @keydown.meta.enter.exact.prevent="onConfirmShortcut"
  >
<!--    <div id="global-loader" >-->
<!--			<div class="whirly-loader"> </div>-->
<!--		</div>-->

		<!-- Main Wrapper -->
		<div class="main-wrapper">
			<div class="page-wrapper pos-pg-wrapper ms-0">
				<div class="content pos-design p-0">
<!--					<div class="btn-row d-sm-flex align-items-center">-->
<!--						<a href="javascript:void(0);" class="btn btn-secondary mb-xs-3" data-bs-toggle="modal" data-bs-target="#orders"><span class="me-1 d-flex align-items-center"><i data-feather="shopping-cart" class="feather-16"></i></span>View Orders</a>-->
<!--						<a href="javascript:void(0);" class="btn btn-info"><span class="me-1 d-flex align-items-center"><i data-feather="rotate-cw" class="feather-16"></i></span>Reset</a>-->
<!--						<a href="javascript:void(0);" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#recents"><span class="me-1 d-flex align-items-center"><i data-feather="refresh-ccw" class="feather-16"></i></span>Transaction</a>-->
<!--					</div>-->

					<div class="row align-items-start pos-wrapper">
						<div class="col-md-12 col-lg-6">
							<aside class="product-order-list">
                <div class="customer-info block-section position-relative">

                  <!-- Customer Select and Create Button -->
                  <div class="input-block d-flex align-items-center mb-3">
                    <div class="col-6 d-flex me-3">
                      <div class="flex-grow-1">
                        <input
                          type="text"
                          v-model="c_query"
                          @focus="clearCustomerSearch"
                          @input="searchCustomer"
                          placeholder="Search Customer by Name, phone no"
                          class="form-control"
                          @keydown="handleKey"
                        />

                        <!-- Dropdown Search Results -->
                        <div
                          v-if="c_query"
                          class="search-results shadow rounded bg-white position-absolute mt-2"
                          style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
                          :class="{ 'd-block': c_results.length > 0, 'd-none': c_results.length === 0 }"
                        >

                          <!-- Results List -->
                          <ul class="list-group list-group-flush">
                            <li
                              v-for="(customer, index) in c_results"
                              :key="customer.id"
                              class="list-group-item d-flex justify-content-between align-items-center"
                              :class="{ 'bg-primary text-white': index === selectedCustomerIndex }"
                              style="padding: 14px; font-size: 1rem; cursor: pointer;"
                              @click="selectCustomer(customer)"
                            >
                              <div class="flex-grow-1">
                                <strong>{{ customer.customer_name }}</strong> - {{ customer.customer_phone }}
                              </div>
                            </li>
                          </ul>

                          <!-- No Results -->
                          <div v-if="!c_results.length" class="text-center text-muted py-4" style="font-size: 1rem;">
                            No results found
                          </div>
                        </div>
                      </div>
                      <a href="#" class="btn btn-primary btn-icon ms-2" data-bs-toggle="modal" data-bs-target="#create">
                        <i class="ti ti-users-plus text-white"></i>
                      </a>
                    </div>
                    <div class="col-6 d-flex flex-column gap-1">
                      <span><strong>Latest Invoice No: #{{ voucher_id }}</strong></span>
                      <span class="d-flex align-items-center gap-2">
                        <strong>Next Invoice No: #{{ next_invoice_id }}</strong>
                        <span class="pos-invoice-date" title="Invoice date. A past date uses that day's invoice number.">
                          <button type="button" class="pos-invoice-date-btn" aria-label="Choose invoice date"
                                  @click="openInvoiceDate">
                            <i class="ti ti-calendar"></i>
                          </button>
                          <input ref="invoiceDateInput" v-model="invoice_date" type="date" :max="today"
                                 @change="posInvoiceNo" @click="openInvoiceDate" />
                        </span>
                      </span>
                    </div>
                  </div>

                  <!-- Search Input -->
                  <div class="position-relative">
                    <input
                      ref="itemSearchInput"
                      type="text"
                      v-model="query"
                      @input="onItemSearchInput"
                      :placeholder="$t('search_item_by_name_barcode_serial')"
                      class="form-control search-input-with-clear"
                      autocomplete="off"
                      @keydown="handleKeys"
                    />
                    <button
                      v-if="query || results.length"
                      type="button"
                      class="search-clear"
                      :title="$t('clear') || 'Clear'"
                      @click="clearSearch"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>

                  <!-- Dropdown Search Results -->
                  <div
                    v-if="results.length"
                    class="search-results shadow rounded bg-white position-absolute w-100 mt-2"
                    style="max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
                  >
                    <ul class="list-group list-group-flush">
                      <li
                        v-for="(item, index) in results"
                        :key="getCartKey(item)"
                        class="list-group-item d-flex justify-content-between align-items-center"
                        :class="{ 'bg-primary text-white': index === selectedItem }"
                        style="padding: 10px; gap: 12px;"
                      >
                        <!-- Product Info -->
                        <div
                          class="flex-grow-1 d-flex flex-column"
                          @click="addItem(item)"
                          style="cursor: pointer;"
                        >
                          <div class="d-flex align-items-center gap-2">

                            <!-- Product Image -->
                            <div
                              style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                            >
                              <img
                                :src="$getRowImageUrl(item)"
                                alt="Item"
                                style="width:100%; height:100%; object-fit:cover;"
                              />
                            </div>

                            <!-- Product Details -->
                            <div class="d-flex flex-column">

                              <strong class="text-dark">
                                {{ item.item_name }} - {{ item.item_code }}
                              </strong>

                              <span
                                v-if="item.serial_number"
                                class="fw-semibold"
                                style="font-size:0.8rem;color:#198754;"
                              >
                                {{ $t('serial_number') }}: {{ item.serial_number }}
                              </span>

                              <span
                                v-if="!item.serialized_unit_id"
                                style="font-size:0.75rem;color:black;"
                              >
                                Stock: {{ getAvailableStock(item) }}
                              </span>

                              <!-- Parent cards hide price; variant / serial rows show it -->
                              <span
                                v-if="!isVariantParent(item)"
                                style="font-size:0.75rem;color:black;"
                              >
                                {{ $t('selling_price') }}: {{ formatMoney(item.selling_price ?? 0) }}
                              </span>

                              <!-- Variant Information (multi-variant + warranty variants) -->
                              <template v-if="item.variant_id || item.variant_attributes?.length">
                                <span
                                  v-if="item.sku"
                                  style="font-size:0.75rem;color:black;"
                                >
                                  SKU: {{ item.sku }}
                                </span>

                                <span
                                  v-if="item.barcode_qr_code && !item.serialized_unit_id"
                                  style="font-size:0.75rem;color:black;"
                                >
                                  Barcode: {{ item.barcode_qr_code }}
                                </span>

                                <span
                                  v-if="item.variant_attributes?.length"
                                  style="font-size:0.75rem;color:black;"
                                >
                                  {{
                                    item.variant_attributes
                                      .map(v => `${v.attribute}: ${v.value}`)
                                      .join(' | ')
                                  }}
                                </span>
                              </template>
                            </div>
                          </div>
                        </div>

                        <!-- Quantity (hidden for warranty serials — always 1) -->
                        <input
                          v-if="!item.serialized_unit_id"
                          type="number"
                          min="1"
                          :max="getAvailableStock(item)"
                          v-model.number="item.quantity"
                          placeholder="1"
                          class="form-control form-control-sm"
                          style="width:80px;"
                          @click.stop
                        />

                        <!-- Add Button -->
                        <button
                          class="btn btn-sm btn-success"
                          @click.stop="addItem(item)"
                        >
                          {{ $t('add') || 'Add' }}
                        </button>

                      </li>
                    </ul>

                    <div
                      v-if="!results.length"
                      class="text-center text-muted py-4"
                    >
                      No results found
                    </div>
                  </div>
                </div>

								<div class="product-added block-section border rounded">
                  <div class="order-total px-1 py-3">
                    <div class="head-text d-flex align-items-center justify-content-between border-bottom">
                      <h6 class="d-flex align-items-center mb-2">Item Added<span class="badge bg-primary ms-2">{{addedItems.length}}</span></h6>
                      <a
                        v-if="addedItems.length"
                        class="d-flex align-items-center text-danger"
                        @click="clearAll"
                      >
                        <span class="me-1">
                          <i data-feather="x" class="feather-16"></i>
                        </span>Clear all
                      </a>
                    </div>

                    <div class="product-wrap">
                      <div
                        class="product-list d-flex align-items-center justify-content-between flex-nowrap gap-2 px-2 bg-white"
                        v-for="(item, index) in addedItems"
                        :key="item.id"
                        style="height: 70px; border-bottom: 1px solid #e9ecef;"
                      >
                        <!-- Product Info -->
                        <div
                          class="d-flex align-items-center product-info min-w-0 overflow-hidden flex-grow-1"
                          style="width: auto;"
                        >
                          <div
                            class="flex-shrink-0"
                            style="width:50px; height:50px; border-radius:4px; overflow:hidden;"
                          >
                            <img
                              :src="$getRowImageUrl(item)"
                              alt="Items"
                              style="width:100%; height:100%; object-fit:cover;"
                            />
                          </div>
                          <div
                            class="ms-2 min-w-0 text-truncate fw-bold"
                            style="font-size: 14px;"
                            :title="getAddedItemLabel(item)"
                          >
                            {{ getAddedItemLabel(item) }}
                          </div>

                          <div
                            class="ms-2 flex-shrink-0 text-nowrap"
                            v-if="item.campaign_id && getCampaignUnitDiscountForItem(item) > 0"
                          >
                            <span class="text-success" style="font-size: 12px;">
                              - ({{ $t('campaign_discount') }} ৳{{ formatMoney(getCampaignUnitDiscountForItem(item)) }})
                            </span>
                          </div>
                          <div
                            class="ms-2 flex-shrink-0 text-nowrap"
                            v-else-if="isItemDiscountSource() && Number(item.discount) > 0"
                          >
                            <span class="text-success" style="font-size: 12px;">
                              - (Discount {{ Number(item.discount).toFixed(0) }}%)
                            </span>
                          </div>
                        </div>

                        <!-- Quantity -->
                        <div class="qty-item d-flex justify-content-center align-items-center flex-shrink-0">

                          <!-- Decrease -->
                          <button
                            type="button"
                            class="qty-btn qty-btn-minus d-flex justify-content-center align-items-center"
                            @click="decreaseQty(item)"
                            :disabled="item.quantity <= 1"
                            title="Decrease quantity"
                            aria-label="Decrease quantity"
                          >
                            <i data-feather="minus-circle" class="feather-14"></i>
                          </button>

                          <!-- Quantity -->
                          <input
                            type="number"
                            class="form-control text-center qty-input"
                            name="qty"
                            v-model="item.quantity"
                            :max="getAvailableStock(item)"
                            min="1"
                            @input="validateQty(item)"
                            aria-label="Quantity"
                          >

                          <!-- Increase -->
                          <button
                            type="button"
                            class="qty-btn qty-btn-plus d-flex justify-content-center align-items-center"
                            @click="increaseQty(item)"
                            :disabled="item.quantity >= getAvailableStock(item)"
                            title="Increase quantity"
                            aria-label="Increase quantity"
                          >
                            <i data-feather="plus-circle" class="feather-14"></i>
                          </button>
                        </div>

                        <!-- Delete -->
                        <div class="action d-flex align-items-center flex-shrink-0">
                          <a class="btn-icon delete-icon confirm-text" @click="removeItem(item)">
                            <i data-feather="trash-2" class="feather-14"></i>
                          </a>
                        </div>

                        <!-- Total Price -->
                        <div class="total-price ms-1 flex-shrink-0 text-nowrap text-end">
                          <strong>৳{{ formatMoney((Number(item.quantity || 0) * Number(item.selling_price || 0))) }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
								</div>
							</aside>
						</div>

            <div class="col-md-12 col-lg-3 ps-0">
              <aside class="product-order-list">
                <div class="block-section">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td class="text-end"><strong style="font-size: 1.25rem">৳{{ formatMoney(calculateSubtotal()) }}</strong></td>
                      </tr>
                      <tr>
                        <td>Vat</td>
                        <td class="text-end"><strong style="font-size: 1.25rem">৳{{ formatMoney(vatAmount) }}</strong></td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="pos-discount-block">
                            <div class="pos-discount-main">
                              <div class="d-flex align-items-center gap-2 digital-pay-row">
                                <span class="text-nowrap pos-pay-label">Discount (%):</span>
                                <input type="number"
                                  v-model.number="discountPercent"
                                  class="form-control form-control-sm pos-discount-field"
                                  min="0" :max="maxDiscountPercent"
                                  :disabled="!canEditDiscountPercent"
                                />
                              </div>
                              <div class="d-flex align-items-center gap-2 digital-pay-row mt-1">
                                <span class="text-nowrap pos-pay-label">Discount Amount:</span>
                                <input type="number"
                                  v-model.number="discountFixed"
                                  class="form-control form-control-sm pos-discount-field"
                                  min="0"
                                  :disabled="!canEditDiscountAmount"
                                />
                              </div>
                            </div>
                            <strong class="pos-discount-value">
                              ৳{{ formatMoney(calculateDiscount()) }}
                            </strong>
                          </div>
                        </td>
                      </tr>

                      <tr class="pos-total-payable-row">
                        <td>Total Payable</td>
                        <td class="text-end" style="font-size: 1.25rem;"><strong>৳{{ formatMoney(calculateTotal()) }}</strong></td>
                      </tr>

                      <tr>
                        <td class="fw-semibold">
                          Cash Received (ctrl+c):
                        </td>
                        <td class="text-end">
                          <input
                            ref="cashReceivedInput"
                            type="text"
                            v-model="receivedAmount"
                            @input="receivedAmount = receivedAmount.replace(/[^0-9]/g, '')"
                            class="form-control form-control-sm big-placeholder pos-amount-input pos-cash-received"
                            placeholder="৳0"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <div class="d-flex align-items-center gap-2 digital-pay-row">
                            <span class="fw-semibold text-nowrap pos-pay-label">Digital Pay (ctrl+b):</span>
                            <FormDropdown
                              ref="digitalPayDropdown"
                              v-model="payment_method"
                              :options="formattedpaymenttypes"
                              placeholder="Select"
                              clearable
                              @change="onDigitalPaymentChange"
                              class="digital-pay-select"
                            />
                            <input
                              ref="digitalPayAmountInput"
                              type="text"
                              v-model="bankAmount"
                              :disabled="!payment_method"
                              @input="bankAmount = bankAmount.replace(/[^0-9]/g, '')"
                              class="form-control form-control-sm big-placeholder pos-amount-input"
                              placeholder="৳0"
                            />
                          </div>
                          <div v-if="errors.payment_method" class="text-danger mt-1">{{ errors.payment_method }}</div>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <div class="d-flex align-items-center gap-2 digital-pay-row">
                            <span class="fw-semibold text-nowrap pos-pay-label">Reference No:</span>
                            <input
                              type="text"
                              v-model="reference_no"
                              class="form-control form-control-sm big-placeholder pos-reference-field"
                              placeholder="Enter Reference No"
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <!-- Due -->
                        <td class="text-start">
                          <span class="fw-semibold me-1">Due:</span>
                          <strong
                            v-if="isPayable"
                            class="text-danger pos-due-change-amount"
                          >
                            ৳{{ formatGrossMoney(dueAmount) }}
                          </strong>
                          <strong v-else class="text-muted pos-due-change-amount">
                            ৳0
                          </strong>
                        </td>

                        <!-- Change vs gross (whole) payable; Rounding = gross − net -->
                        <td class="text-end">
                          <div>
                            <span class="fw-semibold me-1">Change:</span>
                            <strong
                              v-if="isReturn"
                              class="text-success pos-due-change-amount"
                            >
                              ৳{{ formatGrossMoney(returnAmount) }}
                            </strong>
                            <strong v-else class="text-muted pos-due-change-amount">
                              ৳0
                            </strong>
                          </div>
                          <div
                            v-if="Math.abs(invoiceRoundingAmount) >= 0.01"
                            class="small mt-1"
                            :class="invoiceRoundingAmount > 0 ? 'text-success' : 'text-danger'"
                          >
                            Rounding: ৳{{ formatSignedMoney(invoiceRoundingAmount) }}
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div class="payment-actions d-grid gap-2 mt-3">
                    <button @click="submitPayment" :disabled="submittingPayment" type="button" class="btn btn-success action-btn w-100 py-3" style="font-size: 1.25rem; font-weight: 600;" aria-label="Confirm payment">
                      {{ submittingPayment ? 'Saving...' : 'Confirm Payment (ctrl/⌘+enter)' }}
                    </button>
                  </div>
                </div>
              </aside>
            </div>

						<div class="col-md-12 col-lg-3 ps-0">
              <div class="pos-categories tabs_wrapper">
                  <div class="pos-products">
                    <div class="d-flex align-items-center justify-content-between">
                      <h5 class="mb-3">Best Selling Products</h5>
                    </div>
                    <div class="tabs_container">
                      <div  class="tab_content active" data-tab="all">
                        <div class="row">
                          <div
                            v-for="product in bestSellingProducts"
                            :key="product.id"
                            class="col-sm-2 col-md-6 col-lg-6 col-xl-6"
                          >
                            <div class="product-info default-cover card" @click="addItem(product)">
                              <a href="javascript:void(0);" class="img-bg">
                                <img
                                  :src="$getRowImageUrl(product)"
                                  alt="Items"
                                  style="width:80%; height:80%; object-fit:cover;"
                                />
                                <span>
                                  <i data-feather="check" class="feather-16"></i>
                                </span>
                              </a>

                              <h6 class="product-name">{{ product.item_name }}</h6>
                              <h6 class="product-name">
                                <template v-if="product.variant_id">
                                 - (<template v-for="(variant, index) in product.variant_attributes" :key="index" >
                                    {{ variant.value }}
                                    <span v-if="index < product.variant_attributes.length - 1" > - </span>
                                  </template>)
                                </template>
                              </h6>

                              <div class="d-flex align-items-center justify-content-between price">
                                <span>{{ getAvailableStock(product) }} Pcs</span>
                                <p>৳{{ formatMoney(product.selling_price) }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- /Main Wrapper -->

		<!-- Payment Completed -->
		<div class="modal fade modal-default" id="payment-completed" aria-labelledby="payment-completed">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-body text-center">
						<form action="pos.html">
							<div class="icon-head">
								<a href="javascript:void(0);">
									<i data-feather="check-circle" class="feather-40"></i>
								</a>
							</div>
							<h4>Payment Completed</h4>
							<p class="mb-0">Do you want to Print Receipt for the Completed Order</p>
							<div class="modal-footer d-sm-flex justify-content-between">
								<button type="button" class="btn btn-primary flex-fill" data-bs-toggle="modal" data-bs-target="#print-receipt">Print Receipt<i class="feather-arrow-right-circle icon-me-5"></i></button>
								<button type="submit" class="btn btn-secondary flex-fill">Next Order<i class="feather-arrow-right-circle icon-me-5"></i></button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Payment Completed -->

		<!-- Print Receipt -->
		<div class="modal fade modal-default" id="print-receipt" aria-labelledby="print-receipt">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="d-flex justify-content-end">
						<button type="button" class="close p-0" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="icon-head text-center">
							<a href="javascript:void(0);">
								<img src="/assets/img/logo.svg" width="100" height="30" alt="Receipt Logo">
							</a>
						</div>
						<div class="text-center info text-center">
							<h6>Dreamguys Technologies Pvt Ltd.,</h6>
							<p class="mb-0">Phone Number: +1 5656665656</p>
							<p class="mb-0">Email: <a href="mailto:example@gmail.com">example@gmail.com</a></p>
						</div>
						<div class="tax-invoice">
							<h6 class="text-center">Tax Invoice</h6>
							<div class="row">
								<div class="col-sm-12 col-md-6">
									<div class="invoice-user-name"><span>Name: </span><span>John Doe</span></div>
									<div class="invoice-user-name"><span>Invoice No: </span><span>CS132453</span></div>
								</div>
								<div class="col-sm-12 col-md-6">
									<div class="invoice-user-name"><span>Customer Id: </span><span>#LL93784</span></div>
									<div class="invoice-user-name"><span>Date: </span><span>01.07.2022</span></div>
								</div>
							</div>
						</div>
						<table class="table-borderless w-100 table-fit">
							<thead>
								<tr>
									<th>Item</th>
									<th>Price</th>
									<th>Qty</th>
									<th class="text-end">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>1. Red Nike Laser</td>
									<td>৳50</td>
									<td>3</td>
									<td class="text-end">৳150</td>
								</tr>
								<tr>
									<td>2. Iphone 14</td>
									<td>৳50</td>
									<td>2</td>
									<td class="text-end">৳100</td>
								</tr>
								<tr>
									<td>3. Apple Series 8</td>
									<td>৳50</td>
									<td>3</td>
									<td class="text-end">৳150</td>
								</tr>
								<tr>
									<td colspan="4">
										<table class="table-borderless w-100 table-fit">
                      <tbody>
                        <tr>
                          <td>Sub Total :</td>
                          <td class="text-end">৳700.00</td>
                        </tr>
                        <tr>
                          <td>Discount :</td>
                          <td class="text-end">-৳50.00</td>
                        </tr>
                        <tr>
                          <td>Shipping :</td>
                          <td class="text-end">0.00</td>
                        </tr>
                        <tr>
                          <td>Tax (5%) :</td>
                          <td class="text-end">৳5.00</td>
                        </tr>
                        <tr>
                          <td>Total Bill :</td>
                          <td class="text-end">৳655.00</td>
                        </tr>
                        <tr>
                          <td>Due :</td>
                          <td class="text-end">৳0.00</td>
                        </tr>
                        <tr>
                          <td>Total Payable :</td>
                          <td class="text-end">৳655.00</td>
                        </tr>
                      </tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="text-center invoice-bar">
							<p>**VAT against this challan is payable through central registration. Thank you for your business!</p>
							<a href="javascript:void(0);">
								<img src="/assets/img/barcode/barcode-03.jpg" alt="Barcode">
							</a>
							<p>Sale 31</p>
							<p>Thank You For Shopping With Us. Please Come Again</p>
							<a href="javascript:void(0);" class="btn btn-primary">Print Receipt</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Print Receipt -->

		<!-- Products -->
		<div class="modal fade modal-default pos-modal" id="products" aria-labelledby="products">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4 d-flex align-items-center justify-content-between">
						<div class="d-flex align-items-center">
							<h5 class="me-4">Products</h5>
							<span class="badge bg-info d-inline-block mb-0">Order ID : #666614</span>
						</div>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<div class="product-wrap">
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-16.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>

								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-17.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0235</span>
												<h6><a href="javascript:void(0);">Iphone 14</a></h6>
											</div>
											<p>৳3000</p>
										</div>
									</div>
								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-16.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>
								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-17.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>
								</div>
							</div>
							<div class="modal-footer d-sm-flex justify-content-end">
								<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="submit" class="btn btn-primary">Submit</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Products -->

    <!-- Create Customer Modal -->
    <div class="modal fade" id="create" tabindex="-1" aria-labelledby="createCustomerLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="submitCustomer">
            <div class="modal-header">
              <h5 class="modal-title" id="createCustomerLabel">{{ $t("add_new_customer") }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <!-- Customer Name -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Customer Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="customer.customer_name"
                    class="form-control"
                    placeholder="Enter customer name"
                  />
                  <div v-if="errors.customer_name" class="text-danger mt-1">{{ errors.customer_name }}</div>
                </div>

                <!-- Phone -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Phone <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="customer.customer_phone"
                    class="form-control"
                    placeholder="Enter phone number"
                  />
                  <div v-if="errors.customer_phone" class="text-danger mt-1">{{ errors.customer_phone }}</div>
                </div>

                <!-- Customer Code -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Customer Code </label>
                  <input
                    type="number"
                    v-model.number="customer.customer_code"
                    class="form-control"
                    placeholder="Enter customer code"
                  />
                  <div v-if="errors.customer_code" class="text-danger mt-1">{{ errors.customer_code }}</div>
                </div>

                <!-- Due Limit -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Due Limit</label>
                  <input
                    type="number"
                    step="0.01"
                    v-model.number="customer.due_limit"
                    class="form-control"
                    placeholder="Enter due limit"
                  />
                  <div v-if="errors.due_limit" class="text-danger mt-1">{{ errors.due_limit }}</div>
                </div>

                <!-- Due Limit Days -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Due Limit Days</label>
                  <input
                    type="number"
                    v-model.number="customer.due_limit_days"
                    class="form-control"
                    placeholder="Enter due limit days"
                  />
                  <div v-if="errors.due_limit_days" class="text-danger mt-1">{{ errors.due_limit_days }}</div>
                </div>

                <!-- Customer Address -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Address</label>
                  <input
                    type="text"
                    v-model="customer.customer_address"
                    class="form-control"
                    placeholder="Enter customer address"
                  />
                  <div v-if="errors.customer_address" class="text-danger mt-1">{{ errors.customer_address }}</div>
                </div>

                <!-- Customer Bank -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Bank</label>
                  <input
                    type="text"
                    v-model="customer.customer_bank"
                    class="form-control"
                    placeholder="Enter customer bank"
                  />
                  <div v-if="errors.customer_bank" class="text-danger mt-1">{{ errors.customer_bank }}</div>
                </div>

                <!-- Contact Person -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Contact Person</label>
                  <input
                    type="text"
                    v-model="customer.customer_contact_person"
                    class="form-control"
                    placeholder="Enter contact person"
                  />
                  <div v-if="errors.customer_contact_person" class="text-danger mt-1">{{ errors.customer_contact_person }}</div>
                </div>

                <!-- Email -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Email </label>
                  <input
                    type="email"
                    v-model="customer.customer_email"
                    class="form-control"
                    placeholder="Enter email"
                  />
                  <div v-if="errors.customer_email" class="text-danger mt-1">{{ errors.customer_email }}</div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div class="btn-addproduct mb-4">
                <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
                <button type="submit" class="btn btn-submit">{{ $t('submit') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

		<!-- Hold -->
		<div class="modal fade modal-default pos-modal" id="hold-order" aria-labelledby="hold-order">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4">
						<h5>Hold order</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<h2 class="text-center p-4">4500.00</h2>
							<div class="input-block">
								<label>Order Reference</label>
								<input class="form-control" type="text" value="" placeholder="">
							</div>
							<p>The current order will be set on hold. You can retreive this order from the pending order button. Providing a reference to it might help you to identify the order more quickly.</p>
							<div class="modal-footer d-sm-flex justify-content-end">
								<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="submit" class="btn btn-primary">Confirm</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Hold -->

		<!-- Edit Product -->
		<div class="modal fade modal-default pos-modal" id="edit-product" aria-labelledby="edit-product">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4">
						<h5>Red Nike Laser</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<div class="row">
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Product Name <span>*</span></label>
										<input type="text" placeholder="45">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Tax Type <span>*</span></label>
										<select class="select">
											<option>Exclusive</option>
											<option>Inclusive</option>
										</select>
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Tax <span>*</span></label>
										<input type="text" placeholder="% 15">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Discount Type <span>*</span></label>
										<select class="select">
											<option>Percentage</option>
											<option>Early payment discounts</option>
										</select>
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Discount <span>*</span></label>
										<input type="text" placeholder="15">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Sale Unit <span>*</span></label>
										<select class="select">
											<option>Kilogram</option>
											<option>Grams</option>
										</select>
									</div>
								</div>
							</div>

							<div class="modal-footer d-sm-flex justify-content-end">
								 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
	        					<button type="submit" class="btn btn-primary">Submit</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Edit Product -->

		<!-- Recent Transactions -->
		<div class="modal fade pos-modal" id="recents" tabindex="-1"    aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header p-4">
						 <h5 class="modal-title" >Recent Transactions</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<div class="tabs-sets">
							<ul class="nav nav-tabs" id="myTab" role="tablist">
								<li class="nav-item" role="presentation">
								  <button class="nav-link active" id="purchase-tab" data-bs-toggle="tab" data-bs-target="#purchase" type="button"   aria-controls="purchase" aria-selected="true" role="tab">Purchase</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="payment-tab" data-bs-toggle="tab" data-bs-target="#payment" type="button"   aria-controls="payment" aria-selected="false" role="tab">Payment</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="return-tab" data-bs-toggle="tab" data-bs-target="#return" type="button"   aria-controls="return" aria-selected="false" role="tab">Return</button>
								</li>
							  </ul>
							  <div class="tab-content" >
								<div class="tab-pane fade show active" id="purchase" role="tabpanel" aria-labelledby="purchase-tab">
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="tab-pane fade" id="payment" role="tabpanel" >
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="tab-pane fade" id="return" role="tabpanel" >
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf" class="d-flex align-items-center justify-content-center"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" class="d-flex align-items-center justify-content-center"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Print" class="d-flex align-items-center justify-content-center"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Recent Transactions -->

		<!-- Recent Transactions -->
		<div class="modal fade pos-modal" id="orders" tabindex="-1"  aria-hidden="true">
			<div class="modal-dialog modal-md modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header p-4">
						 <h5 class="modal-title" >Orders</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<div class="tabs-sets">
							<ul class="nav nav-tabs" id="myTabs" role="tablist">
								<li class="nav-item" role="presentation">
								  <button class="nav-link active" id="onhold-tab" data-bs-toggle="tab" data-bs-target="#onhold" type="button"   aria-controls="onhold" aria-selected="true" role="tab">Onhold</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="unpaid-tab" data-bs-toggle="tab" data-bs-target="#unpaid" type="button"   aria-controls="unpaid" aria-selected="false" role="tab">Unpaid</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="paid-tab" data-bs-toggle="tab" data-bs-target="#paid" type="button"   aria-controls="paid" aria-selected="false" role="tab">Paid</button>
								</li>
							  </ul>
							  <div class="tab-content" >
								<div class="tab-pane fade show active" id="onhold" role="tabpanel" aria-labelledby="onhold-tab">
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input w-100">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666659</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Botsford</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳900</td>
                              </tr>
                              <tr>
															<td>Date</td>
															<td class="colon">:</td>
															<td class="text">29-08-2023 13:39:11</td>
														</tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-sm-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666660</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
															<td>Customer</td>
															<td class="colon">:</td>
															<td class="text">Smith</td>
														</tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳15000</td>
                              </tr>
                              <tr>
															<td>Date</td>
															<td class="colon">:</td>
															<td class="text">30-08-2023 15:59:11</td>
														</tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666661</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">John David</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳2000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">01-09-2023 13:15:00</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>

								</div>
								<div class="tab-pane fade" id="unpaid" role="tabpanel" >
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>

									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666662</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Anastasia</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳2500</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">10-09-2023 17:15:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666663</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Lucia</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳1500</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">11-09-2023 14:50:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666664</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Diego</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳30000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">12-09-2023 17:22:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" id="paid" role="tabpanel" >
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666665</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Hugo</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳5000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">13-09-2023 19:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666666</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Antonio</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳7000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">15-09-2023 18:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666667</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">MacQuoid</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳7050</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">17-09-2023 19:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Recent Transactions -->

		<div class="customizer-links" id="setdata">
			<ul class="sticky-sidebar">
				<li class="sidebar-icons">
					<a href="#" class="navigation-add" data-bs-toggle="tooltip" data-bs-placement="left"
						data-bs-original-title="Theme">
						<i data-feather="settings" class="feather-five"></i>
					</a>
				</li>
			</ul>
		</div>

    <!-- Due Confirmation Modal -->
    <div v-if="showDueModal" class="confirm-backdrop" click.self="cancelDueSale">
      <div class="confirm-modal">

        <div class="confirm-header">
          <h4>Due Sale Confirmation</h4>
        </div>

        <div class="confirm-body">
          <div class="confirm-row">
            <span>Total Amount</span>
            <strong>৳ {{ formatGrossMoney(grossPayable) }}</strong>
          </div>

          <div class="confirm-row">
            <span>Paid Amount</span>
            <strong>৳ {{ formatGrossMoney(totalReceived) }}</strong>
          </div>

          <div class="confirm-row due">
            <span>Due Amount</span>
            <strong>৳ {{ formatGrossMoney(dueAmount) }}</strong>
          </div>
        </div>

        <div class="confirm-actions">
          <button type="button" class="btn btn-secondary" @click="cancelDueSale">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="confirmDueSale">
            Confirm Sale
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import apiUrls from '@/urls'
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';
import { truncateMoney2, formatGrossMoney as toGrossMoney } from '@/utils';
import { openInvoicePrintPreview } from '@/utils/invoicePrintPreview';
import { isAdminUser } from '@/helpers/permission';

function localToday() {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export default {
  data() {
    return {
      customer: {
        customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
        customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
      },

      query: '',
      results: [],
      c_query: '',
      c_results: [],
      selectedItem: 0,
      defaultCustomer: {
        id: 1,
        customer_name: 'Guest Customer',
      },
      selectedCustomer: null,
      selectedCustomerIndex: 0,
      debouncedSearch: null,
      addedItems: [],
      receivedAmount: null,
      bankAmount: null,
      error: null,
      voucher_id: null,
      discountPercent: 0,
      discountFixed: null,
      next_invoice_id: null,
      invoice_date: localToday(),
      today: localToday(),
      reference_no: null,
      digital_payment_type: [],
      payment_method: null,
      total_due: null,
      global_vat_percentage: null,
      vat_policy: null,
      discount_source_policy: null, // 1=Global, 2=Item, 3=No Discount
      global_discount_percentage: 0,
      invoice_rounding_policy: null, // 1=Round Up, 2=Round Down, 3=Decimal — gross/Grand Total only
      errors: {},
      errorMessage: "",
      bestSellingProducts: [],
      submittingPayment: false,
      showDueModal: false,
      dueModalResolver: null,
    }
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  async mounted() {
    // document + capture: more reliable on Firefox macOS than window-only.
    this._onPosShortcut = (event) => this.handlePosShortcut(event);
    document.addEventListener('keydown', this._onPosShortcut, true);

    await this.posInvoiceNo();

    await this.fetchPaymentType();

    await this.fetchVatPercentage();

    await this.fetchBestSellingProducts();

    this.$nextTick(() => this.focusItemSearch());
  },

  beforeUnmount() {
    if (this._onPosShortcut) {
      document.removeEventListener('keydown', this._onPosShortcut, true);
    }
  },

  computed: {
    total() {
      return this.calculateTotal();
    },

    maxDiscountPercent() {
      return isAdminUser() ? 100 : Number(this.global_discount_percentage) || 0;
    },

    /** Global-source discount % editable when no fixed amount is set. */
    canEditDiscountPercent() {
      return this.isGlobalDiscountSource() && !(Number(this.discountFixed) > 0);
    },

    /**
     * Discount Amount editable only when global setting % is 0, policy is global,
     * and Discount (%) is empty — same mutual exclusivity as %.
     */
    canEditDiscountAmount() {
      return this.isGlobalDiscountSource()
        && !(Number(this.global_discount_percentage) > 0)
        && !(Number(this.discountPercent) > 0);
    },

    received() {
      return Number(this.receivedAmount || 0);
    },

    bank() {
      return Number(this.bankAmount || 0);
    },

    totalReceived() {
      return this.received + this.bank;
    },

    netBalance() {
      return this.totalReceived - this.grossPayable;
    },

    /** Whole-taka amount due (Round Up/Down/Decimal on Total Payable) */
    grossPayable() {
      return this.applyInvoiceGrossRound(this.total);
    },

    /**
     * Invoice rounding on payable: gross − net (e.g. 24 − 23.94 = +0.06).
     * + = Round Up / customer pays more; − = Round Down.
     */
    invoiceRoundingAmount() {
      return this.applyInvoiceRound(this.grossPayable - this.total);
    },

    isPayable() {
      return this.totalReceived < this.grossPayable;
    },

    isReturn() {
      return this.totalReceived > this.grossPayable;
    },

    dueAmount() {
      if (!this.isPayable) return 0;
      return this.applyInvoiceGrossRound(this.grossPayable - this.totalReceived);
    },

    /** Total Payable at 4 dp (before invoice gross rounding) */
    payableAmount() {
      let grandTotal = 0;
      for (const item of this.addedItems) {
        const breakdown = this.getItemBreakdown(item);
        if (!breakdown) continue;
        grandTotal += breakdown.linePayable;
      }
      return this.applyInvoiceRound(grandTotal);
    },

    /** Change = cash − gross payable (both whole when cash is integer) */
    returnAmount() {
      if (!this.isReturn) return 0;
      return this.applyInvoiceGrossRound(this.totalReceived - this.grossPayable);
    },

    paymentDifference() {
      return Math.abs(this.grossPayable - Number(this.totalReceived || 0));
    },

    formattedpaymenttypes() {
      if (!Array.isArray(this.digital_payment_type)) return [];
      return this.digital_payment_type.map(pt => ({
        id: pt.id,
        text: pt.text || pt.name
      }));
    },

    // VAT on discounted taxable (discount source is independent of vat_policy)
    vatAmount() {
      let totalVat = 0;
      for (const item of this.addedItems) {
        const breakdown = this.getItemBreakdown(item);
        if (!breakdown) continue;
        totalVat += breakdown.lineVat;
      }
      return this.applyInvoiceRound(totalVat);
    },

    totalWithVat() {
      return this.calculateTotal();
    }
  },

  watch: {
    payment_method(val) {
      if (!val) {
        this.bankAmount = null;
      }
    },

    /** Keep Cash Received in sync with Total Payable (gross) so Due/Change stay correct. */
    grossPayable(val) {
      const amount = Number(val) || 0;
      this.receivedAmount = amount > 0 ? String(Math.round(amount)) : null;
    },

    discountPercent(val) {
      if (val > this.maxDiscountPercent) {
        this.toast.info(`Discount cannot be more than ${this.maxDiscountPercent}%`);
        this.discountPercent = this.maxDiscountPercent;
        return;
      }
      if (val > 0) {
        this.discountFixed = null;
      }
    },

    discountFixed(val) {
      const fixed = parseFloat(val);
      if (!(fixed > 0)) return;

      this.discountPercent = 0;
      // Cap against non-campaign taxable only — campaign lines ignore cashier amount/%.
      const taxable = this.getNonCampaignTaxableSubtotal();
      if (taxable <= 0) {
        this.toast.info('Discount Amount applies only to items without an active campaign.');
        this.discountFixed = null;
        return;
      }

      const maxPct = this.maxDiscountPercent;
      const maxAmount = this.applyInvoiceRound((taxable * maxPct) / 100);
      if (fixed > maxAmount) {
        this.toast.info(
          maxPct < 100
            ? `Discount cannot be more than ${maxPct}% (৳${this.formatMoney(maxAmount)})`
            : `Discount cannot be more than ৳${this.formatMoney(maxAmount)}`
        );
        this.discountFixed = maxAmount;
      }
    },

    global_vat_percentage(newVal) {
      if (isNaN(newVal) || newVal < 0) {
        this.global_vat_percentage = 0;
      } else if (newVal > 100) {
        this.global_vat_percentage = 100;
      }
    },

    vat_policy(newVal) {
      if (
          newVal === 4 /* Price including Item-wise VAT */ ||
          newVal === 5 /* Price excluding Item-wise VAT */
      ) {
        // fetch VAT for ALL existing items
        this.addedItems.forEach(item => {
          this.fetchItemVat(item);
        });
      }
    },
  },

  methods: {
    isModifierPressed(event) {
      // Mac: Control (ctrlKey) or Command (metaKey). Windows/Linux: Control.
      return !!(event.ctrlKey || event.metaKey);
    },

    isEnterKey(event) {
      const key = event.key;
      const code = event.code;
      // Firefox/Safari historically used keyCode 10 for Ctrl+Enter on some platforms.
      return (
        key === 'Enter' ||
        code === 'Enter' ||
        code === 'NumpadEnter' ||
        event.keyCode === 13 ||
        event.keyCode === 10 ||
        event.which === 13 ||
        event.which === 10
      );
    },

    handlePosShortcut(event) {
      if (!this.isModifierPressed(event) || event.altKey || event.shiftKey) return;
      if (event.repeat) return;

      const key = (event.key || '').toLowerCase();

      if (this.isEnterKey(event)) {
        event.preventDefault();
        event.stopPropagation();
        this.onConfirmShortcut();
        return;
      }

      if (key === 'c') {
        event.preventDefault();
        event.stopPropagation();
        this.focusCashReceived();
        return;
      }

      if (key === 'b') {
        event.preventDefault();
        event.stopPropagation();
        this.focusDigitalPay();
      }
    },

    onConfirmShortcut() {
      if (this.submittingPayment || this.showDueModal) return;
      this.submitPayment();
    },

    focusItemSearch() {
      const input = this.$refs.itemSearchInput;
      if (!input) return;
      input.focus({ preventScroll: true });
    },

    focusCashReceived() {
      const input = this.$refs.cashReceivedInput;
      if (!input) return;
      input.focus();
      if (typeof input.select === 'function') input.select();
    },

    focusDigitalPay() {
      // Prefer amount field when a method is already chosen; otherwise open the dropdown.
      if (this.payment_method) {
        const amountInput = this.$refs.digitalPayAmountInput;
        if (amountInput && !amountInput.disabled) {
          amountInput.focus();
          if (typeof amountInput.select === 'function') amountInput.select();
          return;
        }
      }

      const dropdown = this.$refs.digitalPayDropdown;
      const toggle = dropdown?.$el?.querySelector?.('[data-bs-toggle="dropdown"]');
      if (toggle) {
        toggle.focus();
        toggle.click();
      }
    },

    clearCustomerSearch() {
      this.c_query = '';
      this.c_results = [];
      this.selectedCustomerIndex = 0;
    },

    async searchCustomer() {
        if (!this.c_query) {
          this.c_results = []
          return
        }

        try {
          const response = await this.$axios.get(apiUrls.customer_search.get, {
            params: { q: this.c_query }
          })
          this.c_results = response.data.results;
          this.selectedCustomer = 0;

        } catch (error) {
          console.error('Search error:', error)
          this.c_results = []
        }
      },

    async submitCustomer() {
      // Frontend validation before making API call
      this.errors = {};
      if (!this.customer.customer_name.trim()) this.errors.customer_name = this.$t('error.required');
      if (!this.customer.customer_phone.trim()) this.errors.customer_phone = this.$t('error.required');

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      try {
        const response = await this.$axios.post(apiUrls.customers.post, this.customer );
        this.toast.success(this.$t("customer_created"));

        // Close modal
        const modal = bootstrap.Modal.getInstance(document.getElementById("create"));
        modal.hide();

        // Redirect only after successful response
        this.$router.push('/pos');

        this.resetForm();
      } catch (error) {
        const data = error.response?.data || {};
        if (data.error) this.errorMessage = data.error;
        if (data.errors) {
          this.errors = data.errors;
        } else if (data.customer_phone) {
          const message = data.customer_phone;
          this.errors.customer_phone = Array.isArray(message) ? message[0] : message;
        }
      }
    },

    handleKey(event) {
      if (event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowDown') {
        this.selectedCustomerIndex = Math.min(this.selectedCustomerIndex + 1, this.c_results.length - 1);
      } else if (event.key === 'ArrowUp') {
        this.selectedCustomerIndex = Math.max(this.selectedCustomerIndex - 1, 0);
      } else if (event.key === 'Enter') {
        const customer = this.c_results[this.selectedCustomerIndex];
        if (customer) {
          this.selectCustomer(customer);
        }
      }
    },

    customerSearchLabel(customer, due) {
      const parts = [customer.customer_name, customer.customer_phone].filter(Boolean);
      if (due !== undefined && due !== null) parts.push(`${this.formatMoney(due)} BDT`);
      return parts.join(' - ');
    },

    selectCustomer(customer) {
      this.selectedCustomer = { ...customer };
      this.c_query = this.customerSearchLabel(customer);
      this.c_results = [];
      this.selectedCustomerIndex = 0;

      this.fetchCustomerDue(customer.id);
    },

    async fetchCustomerDue(customer_id) {
      try{
        const response = await this.$axios.get(`${apiUrls.customer_due.get}${customer_id}`);
        if (this.selectedCustomer?.id !== customer_id) return;
        this.total_due = response.data.due_balance;
        this.c_query = this.customerSearchLabel(this.selectedCustomer, this.total_due);
      }catch (error) {
        console.error("Error fetching customer due:", error);
      }
    },

    async fetchVatPercentage() {
      try {
        const response = await this.$axios.get(apiUrls.setting.get);
        const data = response.data;
        const setting = Array.isArray(data) ? data[0] : data;
        this.global_vat_percentage = parseFloat(setting.global_vat_percentage) || 0;
        this.vat_policy = setting.vat_policy != null ? Number(setting.vat_policy) : null;
        this.discount_source_policy = setting.discount_source_policy != null
          ? Number(setting.discount_source_policy)
          : null;
        this.global_discount_percentage = parseFloat(setting.global_discount_percentage) || 0;
        this.invoice_rounding_policy = setting.invoice_rounding_policy != null
          ? Number(setting.invoice_rounding_policy)
          : null;
        this.applyDefaultDiscountPercent();
      } catch (error) {
        console.error("Error fetching vat percentage:", error);
      }
    },

    cancelForm() {
      this.resetForm();

      // Close Bootstrap modal programmatically
      const modal = bootstrap.Modal.getInstance(document.getElementById("create"));
      if (modal) modal.hide();
    },

    resetForm() {
      this.customer = {
        customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
        customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
      };
      this.errors = {};
      this.errorMessage = "";
    },

    onItemSearchInput() {
      if (!String(this.query || '').trim()) {
        this.results = [];
        this.selectedItem = 0;
        return;
      }
      this.debouncedSearch();
    },

    async fetchResults(options = {}) {
      const listAll = Boolean(options && options.listAll);
      const q = String(this.query || '').trim();
      if (!listAll && !q) {
        this.results = [];
        return;
      }

      try {
        const response = await this.$axios.get(apiUrls.item_search.get, {
          params: { q: listAll ? '' : q },
        });
        const results = response.data.results || [];
        this.results = results;
        this.selectedItem = 0;

        // Auto-add on exact barcode or warranty serial scan with stock available
        if (!listAll) {
          const exactBarcode =
            results.length === 1 &&
            results[0].barcode_qr_code &&
            results[0].barcode_qr_code === q;
          const exactSerial =
            results.length === 1 &&
            results[0].serialized_unit_id &&
            results[0].serial_number &&
            String(results[0].serial_number).toLowerCase() === q.toLowerCase();

          if (exactBarcode || exactSerial) {
            if (this.getAvailableStock(results[0]) > 0) {
              await this.addItem(results[0]);
              return;
            }
            this.toast.warning(
              'Out of stock. Receive this item in Purchase/Batch first, then sell in POS.'
            );
          }
        }

        await this.$nextTick(() => {
          if (window.feather) feather.replace();
        });
      } catch (error) {
        console.error('Search error:', error);
        this.results = [];
      }
    },

    async handleKeys(event) {
      if (event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!this.results.length) {
          await this.fetchResults({ listAll: true });
          return;
        }
        this.selectedItem = Math.min(this.selectedItem + 1, this.results.length - 1);
      } else if (event.key === 'ArrowUp') {
        this.selectedItem = Math.max(this.selectedItem - 1, 0);
        event.preventDefault();
      } else if (event.key === 'Enter') {
        const selectedProduct = this.results[this.selectedItem];
        if (selectedProduct && (selectedProduct.id || selectedProduct.item_id)) {
          this.addItem(selectedProduct);
        }
        event.preventDefault();
      } else if (event.key === 'Escape') {
        this.clearSearch();
        event.preventDefault();
      }
    },

    async loadVariants(itemId) {
      try {
        const response = await this.$axios.get(
          `/item/${itemId}/variants/`
        )

        const results = response.data.results || [];
        this.results = results;
        this.existingVariants = results;
        this.selectedItem = 0;
        return results;
      } catch (error) {
        console.error(error)
        return [];
      }
    },

    async loadWarrantySerials(item) {
      const itemId = item.item_id || item.id;
      if (!itemId) return [];

      try {
        const params = {
          item_id: itemId,
          status: 'in_stock',
        };
        if (item.variant_id) {
          params.variant_id = item.variant_id;
        }

        const { data } = await this.$axios.get(apiUrls.serialized_units.get, { params });
        const units = data?.results || [];

        if (!units.length) {
          this.toast.warning(
            this.$t('no_unsold_serials')
            || 'No unsold serial numbers available for this product.'
          );
          this.results = [];
          return [];
        }

        const catalogPrice = Number(item.selling_price || 0);
        this.results = units.map((unit) => {
          const batchPrice = Number(unit.selling_price ?? unit.batch_selling_price ?? 0);
          const sellingPrice = catalogPrice > 0 ? catalogPrice : batchPrice;
          return {
            ...item,
            id: item.id || item.item_id,
            item_id: itemId,
            variant_id: unit.variant_id || item.variant_id || null,
            item_type_code: 'WARRANTY',
            serialized_unit_id: unit.id,
            serial_number: unit.serial_number,
            warranty_period_days: unit.warranty_period_days || item.warranty_period_days,
            selling_price: sellingPrice,
            quantity: 1,
            current_stock: 1,
            stock_qty: 1,
            stock_quantity: 1,
          };
        });
        this.selectedItem = 0;
        // Keep query so the dropdown stays open while picking a serial.
        if (!String(this.query || '').trim()) {
          this.query = item.item_name || '';
        }
        return this.results;
      } catch (error) {
        console.error(error);
        this.toast.error('Failed to load serial numbers.');
        this.results = [];
        return [];
      }
    },

    getAvailableStock(item) {
      return Number(
        item.current_stock ??
        item.stock_qty ??
        item.stock_quantity ??
        0
      );
    },

    // Search row for an item that has variants (not one of its variant / serial rows).
    isVariantParent(item) {
      if (!item || item.variant_id || item.serialized_unit_id) return false;
      return item.item_type_code === 'MULTI_VARIANT'
        || item.item_type_code === 'WARRANTY'
        || !!item.has_variants;
    },

    // Variant ids and item ids share number ranges, so namespace the cart key.
    getCartKey(item) {
      if (item.serialized_unit_id) {
        return `s${item.serialized_unit_id}`;
      }
      return item.variant_id ? `v${item.variant_id}` : `i${item.id || item.item_id}`;
    },

    getAddedItemLabel(item) {
      let label = item.item_name || '';

      if (item.variant_id && item.variant_attributes?.length) {
        const variants = item.variant_attributes
          .map(v => `${v.attribute}: ${v.value}`)
          .join(' | ');
        label += ` (${variants})`;
      }

      if (item.serial_number) {
        label += ` [${item.serial_number}]`;
      }

      label += ` - (${this.getAvailableStock(item)})`;

      return label;
    },

    async addItem(item) {
      const stock = this.getAvailableStock(item);
      const outOfStockMessage =
        'Out of stock. Receive this item in Purchase/Batch first, then sell in POS.';

      // WARRANTY: parent → variants (if any) → unsold serials; picking a serial adds to cart.
      if (item.item_type_code === 'WARRANTY' && !item.serialized_unit_id) {
        const itemId = item.id || item.item_id;
        const isParent = !item.variant_id && !item.variant_attributes?.length;
        if (isParent) {
          const variants = await this.loadVariants(itemId);
          if (variants.length) return;
          await this.loadWarrantySerials(item);
          return;
        }
        await this.loadWarrantySerials(item);
        return;
      }

      // Multi-variant parent: always show alert when stock is 0, then list variants
      if (
        item.item_type_code === 'MULTI_VARIANT' &&
        !item.variant_attributes
      ) {
        if (stock <= 0) {
          this.toast.warning(outOfStockMessage);
        }
        await this.loadVariants(item.id)
        return
      }

      if (stock <= 0) {
        this.toast.warning(outOfStockMessage);
        return;
      }

      // const existingItem = this.addedItems.find(i => i.id === item.id);
      const uniqueKey = this.getCartKey(item);

      const existingItem = this.addedItems.find(i => {
        const key = this.getCartKey(i);
        return key === uniqueKey;
      });

      if (existingItem && !item.serialized_unit_id) {
        existingItem.quantity = Math.min(existingItem.quantity + (item.quantity || 1), stock);
        await this.refreshCampaignForItem(existingItem);
      } else if (existingItem && item.serialized_unit_id) {
        this.toast.warning(
          this.$t('serial_already_in_cart') || 'This serial is already in the cart.'
        );
      } else {
        const newItem = {
          ...item,
          images: item.images || [],
          quantity: item.serialized_unit_id ? 1 : Math.min(item.quantity || 1, stock),
          vat_value: 0,
          campaign_id: null,
          campaign_discount_type: null,
          campaign_discount_value: null,
          campaign_max_discount_amount: null,
          campaign_unit_discount: 0,
        };

        // Fetch item-wise VAT value
        if (
          this.vat_policy === 4 /* Price including Item-wise VAT */ ||
          this.vat_policy === 5 /* Price excluding Item-wise VAT */
        ) {
          await this.fetchItemVat(newItem);
        }

        await this.refreshCampaignForItem(newItem);
        this.addedItems = [...this.addedItems, newItem];
      }

      // Clear search UI
      this.query = '';
      this.results = [];
      this.selectedItem = 0;

      this.$nextTick(() => {
        if (window.feather) feather.replace();
      });
    },

    async refreshCampaignForItem(item) {
      try {
        const vatRate = this.getAppliedVatRate(item);
        const policy = Number(this.vat_policy);
        const priceIncludesVat = policy === 2 || policy === 4;
        const { data } = await this.$axios.post(apiUrls.discount_campaign.preview_line, {
          item_id: item.id || item.item_id,
          variant_id: item.variant_id || 0,
          vat_rate: vatRate,
          price_includes_vat: priceIncludesVat,
        });
        if (data?.campaign) {
          item.campaign_id = data.campaign.id;
          item.campaign_discount_type = data.campaign.discount_type;
          item.campaign_discount_value = Number(data.campaign.discount_value || 0);
          item.campaign_max_discount_amount = data.campaign.max_discount_amount != null
            ? Number(data.campaign.max_discount_amount)
            : null;
          // Prefer server unit discount (Decimal-rounded); fall back to local mirror.
          const serverUnit = Number(data.unit_discount || 0);
          item.campaign_unit_discount = serverUnit > 0
            ? serverUnit
            : this.calculateCampaignUnitDiscount(item, this.getTaxableUnitPrice(item), priceIncludesVat, vatRate);
        } else {
          item.campaign_id = null;
          item.campaign_discount_type = null;
          item.campaign_discount_value = null;
          item.campaign_max_discount_amount = null;
          item.campaign_unit_discount = 0;
        }
      } catch (err) {
        console.warn('Campaign preview failed', err?.response?.data || err);
        item.campaign_id = null;
        item.campaign_discount_type = null;
        item.campaign_discount_value = null;
        item.campaign_max_discount_amount = null;
        item.campaign_unit_discount = 0;
      }
    },

    async refreshCampaignsForCart() {
      await Promise.all(this.addedItems.map((item) => this.refreshCampaignForItem(item)));
      // Force computed totals to re-read campaign fields.
      this.addedItems = this.addedItems.map((item) => ({ ...item }));
    },

    /**
     * Mirror backend discount_campaigns.calculate_campaign_unit_discount for display.
     * Checkout still recalculates authoritatively on the server.
     */
    calculateCampaignUnitDiscount(item, taxableUnit, priceIncludesVat, vatRate) {
      const type = item.campaign_discount_type;
      const value = Number(item.campaign_discount_value || 0);
      const taxable = Number(taxableUnit || 0);
      const regular = Number(item.selling_price || 0);
      if (!type || taxable <= 0 || value < 0) return 0;

      if (type === 'percentage') {
        if (!(value > 0) || value > 100) return 0;
        let raw = (taxable * value) / 100;
        const cap = item.campaign_max_discount_amount;
        if (cap != null && Number(cap) >= 0) raw = Math.min(raw, Number(cap));
        return Math.min(this.applyInvoiceRound(raw), taxable);
      }
      if (type === 'fixed_amount') {
        if (!(value > 0)) return 0;
        return this.applyInvoiceRound(Math.min(value, regular, taxable));
      }
      if (type === 'promotional_price') {
        if (value < 0 || value >= regular) return 0;
        let promoTaxable = value;
        if (priceIncludesVat && Number(vatRate) > 0) {
          promoTaxable = value / (1 + Number(vatRate) / 100);
        }
        const raw = taxable - promoTaxable;
        if (raw <= 0) return 0;
        return Math.min(this.applyInvoiceRound(raw), taxable);
      }
      return 0;
    },

    getCampaignUnitDiscountForItem(item) {
      if (!item.campaign_id || !item.campaign_discount_type) return 0;
      const vatRate = this.getAppliedVatRate(item);
      const policy = Number(this.vat_policy);
      const priceIncludesVat = policy === 2 || policy === 4;
      const taxable = this.getTaxableUnitPrice(item);
      // Recompute from current taxable so VAT/price changes stay aligned with server.
      const recomputed = this.calculateCampaignUnitDiscount(
        item, taxable, priceIncludesVat, vatRate
      );
      if (recomputed > 0) return recomputed;
      return Number(item.campaign_unit_discount || 0);
    },

    validateQty(item) {
      if (item.quantity === '' || item.quantity === null) {
        return;
      }

      let quantity = Number(item.quantity);
      const maxStock = Number(this.getAvailableStock(item));

      if (isNaN(quantity)) {
        return;
      }

      if (quantity < 1) {
        item.quantity = 1;
        return;
      }

      if (quantity > maxStock) {
        item.quantity = maxStock;
        return;
      }

      item.quantity = quantity;
    },

    increaseQty(item) {
      const stock = this.getAvailableStock(item);

      if (item.quantity < stock) {
        item.quantity++;
      } else {
        this.toast.warning(`Maximum available stock is ${stock}`);
      }
    },

    decreaseQty(item) {
      if (item.quantity > 1) {
        item.quantity -= 1;
      }
    },

    removeItem(item) {
      const uniqueKey = this.getCartKey(item);

      this.addedItems = this.addedItems.filter(i => {
        const key = this.getCartKey(i);
        return key !== uniqueKey;
      });

      this.$nextTick(() => {
        if (window.feather) feather.replace();
      });
    },

    clearAll() {
      this.addedItems = [];
      this.applyDefaultDiscountPercent();
      this.discountFixed = null;
      this.receivedAmount = null;
      this.bankAmount = null;
      this.$nextTick(() => {
        if (window.feather) feather.replace();
      })
    },

    clearSearch() {
      this.query = '';
      this.results = [];
      this.selectedItem = 0;
      this.$nextTick(() => this.$refs.itemSearchInput?.focus());
    },

    calculateSubtotal() {
      return this.addedItems.reduce((sum, item) =>
        sum + (item.selling_price || 0) * item.quantity, 0);
    },

    isGlobalDiscountSource() {
      return Number(this.discount_source_policy) === 1;
    },

    isItemDiscountSource() {
      return Number(this.discount_source_policy) === 2;
    },

    applyDefaultDiscountPercent() {
      if (this.isGlobalDiscountSource()) {
        this.discountPercent = Number(this.global_discount_percentage) || 0;
      } else {
        this.discountPercent = 0;
      }
    },

    getAppliedVatRate(item) {
      const policy = Number(this.vat_policy);
      if (policy === 2 || policy === 3) {
        return Number(this.global_vat_percentage) || 0;
      }
      if (policy === 4 || policy === 5) {
        return Number(item.vat_value) || 0;
      }
      return 0;
    },

    getTaxableUnitPrice(item) {
      const price = Number(item.selling_price) || 0;
      const rate = this.getAppliedVatRate(item);
      const policy = Number(this.vat_policy);
      const priceIncludesVat = policy === 2 || policy === 4;
      if (priceIncludesVat && rate > 0) {
        return price / (1 + rate / 100);
      }
      return price;
    },

    /** Taxable subtotal (ex-VAT unit × qty) for the whole cart. */
    getTaxableSubtotal() {
      let taxableTotal = 0;
      for (const item of this.addedItems) {
        const qty = Number(item.quantity) || 0;
        const taxable = this.getTaxableUnitPrice(item);
        if (qty > 0 && taxable > 0) taxableTotal += taxable * qty;
      }
      return taxableTotal;
    },

    itemHasActiveCampaign(item) {
      return Boolean(item?.campaign_id && this.getCampaignUnitDiscountForItem(item) > 0);
    },

    /**
     * Taxable base for cashier Discount Amount / % — excludes campaign lines.
     * Campaign products are never affected by Discount Amount or Discount (%).
     */
    getNonCampaignTaxableSubtotal() {
      let taxableTotal = 0;
      for (const item of this.addedItems) {
        if (this.itemHasActiveCampaign(item)) continue;
        const qty = Number(item.quantity) || 0;
        const taxable = this.getTaxableUnitPrice(item);
        if (qty > 0 && taxable > 0) taxableTotal += taxable * qty;
      }
      return taxableTotal;
    },

    /**
     * Convert Discount Amount into a % of non-campaign taxable only, so the full
     * amount (e.g. ৳50) is deducted from non-campaign lines and campaign lines
     * stay on campaign discount alone.
     */
    getFixedDiscountAsPercent() {
      const fixed = parseFloat(this.discountFixed) || 0;
      if (fixed <= 0) return 0;
      const taxable = this.getNonCampaignTaxableSubtotal();
      if (taxable <= 0) return 0;
      return (fixed / taxable) * 100;
    },

    /** Effective global discount % sent through existing line calculations. */
    getAppliedGlobalDiscountPercent() {
      if ((parseFloat(this.discountFixed) || 0) > 0 && !(Number(this.discountPercent) > 0)) {
        return this.getFixedDiscountAsPercent();
      }
      return Number(this.discountPercent) || 0;
    },

    getDiscountPercentForItem(item) {
      if (this.isGlobalDiscountSource()) {
        return this.getAppliedGlobalDiscountPercent();
      }
      if (this.isItemDiscountSource()) {
        return Number(item.discount) || 0;
      }
      return 0;
    },

    /**
     * Standard half-up for line amounts / net payable.
     * Invoice Up/Down policy is NOT applied here.
     */
    applyInvoiceRound(amount, places = 4) {
      const value = Number(amount) || 0;
      const factor = places === 0 ? 1 : Math.pow(10, places);
      const scaled = value * factor;
      return Math.round(scaled) / factor;
    },

    /** Net Total Payable at 2 dp — always half-up. */
    applyInvoicePayableRound(amount) {
      return this.applyInvoiceRound(amount, 2);
    },

    /**
     * Gross payable / Grand Total / cash due — uses Invoice Rounding Policy.
     * 1=Round Up, 2=Round Down, 3/default=Decimal (half-up)
     */
    applyInvoiceGrossRound(amount) {
      const value = Number(amount) || 0;
      const policy = Number(this.invoice_rounding_policy);
      let rounded;
      if (policy === 1) {
        rounded = Math.ceil(value - Number.EPSILON);
      } else if (policy === 2) {
        rounded = Math.floor(value + Number.EPSILON);
      } else {
        rounded = Math.round(value);
      }
      return Math.round(rounded);
    },

    /** Display-only: truncate to 2 dp (no round) from 4 dp values. */
    formatMoney(amount) {
      return truncateMoney2(amount);
    },

    /** Whole-taka display for grand total / due / change. */
    formatGrossMoney(amount) {
      return toGrossMoney(amount);
    },

    /** Signed 2dp truncate for invoice rounding (+ Round Up / − Round Down) */
    formatSignedMoney(amount) {
      const value = Number(amount) || 0;
      const abs = truncateMoney2(Math.abs(value));
      if (value > 0) return `+${abs}`;
      if (value < 0) return `-${abs}`;
      return abs;
    },

    getItemBreakdown(item) {
      const price = Number(item.selling_price) || 0;
      const qty = Number(item.quantity) || 0;
      if (price <= 0 || qty <= 0) return null;

      const vatRate = this.getAppliedVatRate(item);
      const taxable = this.getTaxableUnitPrice(item);
      let discPct = 0;
      let discount;
      // Campaign wins when eligible (1a); otherwise InvSetting discount source.
      const campaignUnit = this.getCampaignUnitDiscountForItem(item);
      if (item.campaign_id && campaignUnit > 0) {
        discount = this.applyInvoiceRound(campaignUnit);
      } else {
        discPct = this.getDiscountPercentForItem(item);
        const discountRaw = discPct > 0 ? (taxable * discPct) / 100 : 0;
        discount = this.applyInvoiceRound(discountRaw);
      }
      const netTaxable = taxable - discount;
      const vatRaw = vatRate > 0 && netTaxable > 0 ? (netTaxable * vatRate) / 100 : 0;
      const vat = this.applyInvoiceRound(vatRaw);
      const lineDiscount = this.applyInvoiceRound(discount * qty);
      const lineVat = this.applyInvoiceRound(vat * qty);
      // Match server: round taxable base (ex-VAT line amount) before payable.
      const lineTaxable = this.applyInvoiceRound(taxable * qty);
      const linePayable = this.applyInvoiceRound(lineTaxable - lineDiscount + lineVat);
      const payable = qty > 0 ? linePayable / qty : 0;

      return {
        qty, taxable, discount, netTaxable, vat, payable, vatRate, discPct,
        lineDiscount, lineVat, lineTaxable, linePayable,
      };
    },

    calculateDiscount() {
      let totalDiscount = 0;
      for (const item of this.addedItems) {
        const breakdown = this.getItemBreakdown(item);
        if (!breakdown) continue;
        totalDiscount += breakdown.lineDiscount;
      }
      return this.applyInvoiceRound(totalDiscount);
    },

    calculateTotal() {
      // Total Payable @ 4 dp; UI truncates to 2 via formatMoney
      return this.payableAmount;
    },

    getPaymentIcon(method) {
      switch (method) {
        case 'Cash':
          return '/assets/img/icons/cash.svg';
        case 'Bank':
          return '/assets/img/icons/bank.png';
        case 'Mobile':
          return '/assets/img/icons/mobile.png';
        default:
          return '';
      }
    },

    openInvoiceDate(event) {
      const input = this.$refs.invoiceDateInput;
      if (!input || event.target === input) return;
      try {
        input.showPicker();
      } catch (error) {
        input.focus();
      }
    },

    async posInvoiceNo() {
      if (this.invoice_date > this.today) this.invoice_date = this.today;
      try {
        const response = await this.$axios.get(apiUrls.pos_new_invoice.get, {
          params: { invoice_date: this.invoice_date },
        });
        this.next_invoice_id = response.data.new_voucher_id;
      } catch (error) {
        console.error("Failed to fetch invoice:", error);
      }
    },

    async fetchPaymentType() {
      try {
        const response = await this.$axios.get(apiUrls.digital_payment_type.get);
        this.digital_payment_type = response.data;
      } catch (error) {
        console.error("Error fetching payment type:", error);
      }
    },

    onDigitalPaymentChange(value) {
      if (!value) {
        this.payment_method = null;
        this.bankAmount = null;
      }
    },

    openDueModal() {
      return new Promise((resolve) => {
        this.dueModalResolver = resolve;
        this.showDueModal = true;
      });
    },

    confirmDueSale() {
      this.showDueModal = false;
      if (this.dueModalResolver) this.dueModalResolver(true);
    },

    cancelDueSale() {
      this.showDueModal = false;
      if (this.dueModalResolver) this.dueModalResolver(false);
    },

    async submitPayment() {
      if (this.submittingPayment) return;

      this.submittingPayment = true;
      try {
        // With due: wait for the due-confirm alert before opening print preview.
        // Without due: open the placeholder during this click so Firefox allows the pop-up.
        let printWindow = null;
        if (!(this.dueAmount > 0)) {
          printWindow = this.openPrintPlaceholder();
        }
        await this.processPayment(printWindow);
      } finally {
        this.submittingPayment = false;
      }
    },

    openPrintPlaceholder() {
      const printWindow = window.open('about:blank', 'hmPosInvoicePrint');
      if (!printWindow) {
        this.toast.warning(
          'Pop-up blocked. Allow pop-ups to open invoice print preview.',
          { timeout: 10000 }
        );
        return null;
      }
      try {
        printWindow.document.write(
          '<!doctype html><title>Print Preview</title>' +
          '<body style="font-family:sans-serif;padding:24px;color:#444">' +
          'Preparing invoice print preview…</body>'
        );
        printWindow.document.close();
      } catch (err) { /* cross-origin / closed */ }
      return printWindow;
    },

    closePrintWindow(printWindow) {
      if (!printWindow || printWindow.closed) return;
      try { printWindow.close(); } catch (err) { /* ignore */ }
    },

    /**
     * POS-owned print preview (same dialog as Invoice Print → Print).
     * Does not navigate to /print/invoice. Closes the preview tab after Print/Cancel.
     */
    async openInvoicePrint(voucherId, printWindow = null) {
      if (!voucherId) {
        this.closePrintWindow(printWindow);
        return;
      }
      try {
        const res = await this.$axios.get(apiUrls.invoice_print.get, {
          params: { voucher_id: String(voucherId), detail: 1 },
        });
        const payload = res.data || {};
        if (!payload.items?.length) {
          this.toast.warning('Invoice not found for print');
          this.closePrintWindow(printWindow);
          return;
        }
        await openInvoicePrintPreview(payload, { targetWindow: printWindow });
      } catch (err) {
        console.error('POS invoice print failed:', err);
        this.closePrintWindow(printWindow);
        this.toast.warning('Sale saved, but print preview failed. Reprint from Invoice Print.', {
          timeout: 10000,
        });
      }
    },

    async processPayment(printWindow = null) {
      // Mutable so due-confirm can open the print window after the alert is accepted.
      const printRef = { win: printWindow };
      const abortPrint = () => this.closePrintWindow(printRef.win);

      // prevent blank payment
      if (!Array.isArray(this.addedItems) || this.addedItems.length === 0) {
        this.toast.warning('No items added for payment');
        abortPrint();
        return;
      }

      // Align screen totals with server campaign resolution before validating payment.
      await this.refreshCampaignsForCart();

      const total = parseFloat(this.calculateTotal());
      const received = parseFloat(this.receivedAmount) || 0;
      const bank = parseFloat(this.bankAmount) || 0;
      const reference = this.reference_no;

      if (bank > 0 && !this.payment_method) {
        this.toast.warning('Please select a digital payment method');
        abortPrint();
        return;
      }

      if (this.payment_method && bank <= 0) {
        this.toast.warning('Please enter digital pay amount');
        abortPrint();
        return;
      }

      // Change is only returned in cash, so digital pay cannot exceed the bill.
      if (bank > this.grossPayable) {
        this.toast.warning('Digital pay amount cannot be more than the Grand Total');
        abortPrint();
        return;
      }

      if (this.payment_method && !reference?.trim()) {
        this.toast.warning('Reference No is required for this payment type');
        abortPrint();
        return;
      }

      const customer_id = this.selectedCustomer?.id || 1;
      if (customer_id === 1 && this.dueAmount) {
        this.toast.info("Guest customer cannot have due.");
        abortPrint();
        return;
      }

      // check customer due limit.
      const due_limit = Number(this.selectedCustomer?.due_limit || 0);
      const total_due = Number(this.total_due || 0);
      const present_due = total_due + Number(this.dueAmount || 0);

      if (due_limit > 0 && (total_due > due_limit || present_due > due_limit)) {
        this.toast.info("Due limit exceeds for this customer");
        abortPrint();
        return;
      }

      if (this.dueAmount > 0) {
        const confirmed = await this.openDueModal();
        if (!confirmed) {
          this.toast.info("Submission cancelled.");
          abortPrint();
          return;
        }
        // Open print preview only after the due sale is confirmed.
        if (!printRef.win) {
          printRef.win = this.openPrintPlaceholder();
        }
      }

      try {
        const discount = parseFloat(this.calculateDiscount()) || 0;
        const customer_id = this.selectedCustomer?.id || 1;

        const payload = {
          sub_total: parseFloat(this.calculateSubtotal()),
          discount,
          tax: parseFloat(this.vatAmount) || 0,
          total,
          received_amount: received || 0,
          bank_amount: bank || 0,
          payment_method: this.payment_method,
          reference_no: reference || 0,
          due_amount: this.dueAmount || 0,
          return_amount: this.returnAmount || 0,
          customer_id,
          invoice_date: this.invoice_date,
          vat_amount: this.vatAmount || 0,
          vat_policy: this.vat_policy,
          global_vat_percentage: this.global_vat_percentage,
          discount_percent: this.isGlobalDiscountSource() ? this.getAppliedGlobalDiscountPercent() : 0,
          discount_source_policy: this.discount_source_policy,
          // Browser print via Invoice Print page (same as /print/invoice)
          client_print: true,

          items: this.addedItems.map(item => {
            const row = {
              item_id: item.id || item.item_id,
              variant_id: item.variant_id || 0,
              item_name: item.item_name,
              quantity: item.quantity,
              selling_price: item.selling_price,
              vatRate: item.vat_value || 0,
              discountRate: item.discount || 0,
            };
            if (item.serialized_unit_id) {
              row.serialized_unit_id = item.serialized_unit_id;
              row.serial_ids = [item.serialized_unit_id];
            } else if (item.serial_ids?.length) {
              row.serial_ids = item.serial_ids;
            }
            return row;
          })
        };

        const response = await this.$axios.post(apiUrls.pos_pay.post, payload);
        this.voucher_id = response.data.voucher_id

        if (response.data?.print_error) {
          this.toast.warning(response.data.print_error, { timeout: 10000 });
        }

        if (response.data && response.data.voucher_id) {
          this.toast.success(`Payment successful. Voucher ID: ${response.data.voucher_id}`);
          await this.openInvoicePrint(response.data.voucher_id, printRef.win);
          await this.posInvoiceNo();
          await this.fetchBestSellingProducts();
          this.c_query = '';
          this.c_results = [];
          this.selectedCustomer = {...this.defaultCustomer};
          this.selectedCustomerIndex = 0;
          this.total_due = null;

        } else {
          this.toast.success('Payment successful!');
          abortPrint();
        }

        this.resetPosEntries();

      } catch (error) {
        abortPrint();
        let message = "An unknown error occurred";

        if (error?.response?.data) {
          const data = error.response.data;

          if (typeof data === "string") {
            message = data;
          } else if (data.detail) {
            message = data.detail;
          } else {
            // handle field errors (DRF serializer errors)
            message = Object.values(data).flat().join(", ");
          }
        } else if (error?.message) {
          message = error.message;
        }

        this.toast.error(`Payment failed: ${message}`);
      }
    },

    async fetchBestSellingProducts() {
      this.loading = true
      try {
        const res = await this.$axios.get(apiUrls.pos_best_selling.get)
        this.bestSellingProducts = res.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async fetchItemVat(item) {

      if (!item?.vat_group) return;

      try {
        const { data } = await this.$axios.get(`${apiUrls.item_vat.get}${item.vat_group}/`);
        const vat = data?.results?.[0];
        item.vat_value = vat ? Number(vat.vat_value) : 0;

        // render feather icons
        await this.$nextTick(() => {
          if (window.feather) feather.replace()
        })
      } catch (error) {
        console.error('Search error:', error)
      }
    },

    isItemWiseVat() {
      return this.vat_policy === 4 /* Price including Item-wise VAT */ ||
          this.vat_policy === 5 /* Price excluding Item-wise VAT */;
    },

    resetPosEntries() {
      this.addedItems = [];
      this.applyDefaultDiscountPercent();
      this.discountFixed = null;
      this.receivedAmount = null;
      this.bankAmount = null;
      this.reference_no = '';
      this.payment_method = null;

      this.selectedCustomer = { ...this.defaultCustomer };
      this.selectedCustomerIndex = 0;
      this.total_due = null;
      this.c_query = '';
      this.c_results = [];
      this.$nextTick(() => {
        if (window.feather) feather.replace();
      })
    },

  },

  created() {
    this.debouncedSearch = debounce(this.fetchResults, 300)

    // initialize customer
    this.selectedCustomer = { ...this.defaultCustomer };
  },
};
</script>

<style>
.pos-invoice-date {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 28px;
  padding: 0 4px 0 2px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  background: #fff;
}

.pos-invoice-date-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #FE9F43;
  cursor: pointer;
}

.pos-invoice-date input {
  width: 124px;
  border: 0;
  background: transparent;
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

/* Keep added-item row on one line (theme defaults to flex-wrap + 60% product-info) */
.product-wrap .product-list {
  flex-wrap: nowrap;
  overflow: hidden;
}
.product-wrap .product-list .product-info {
  width: auto;
  flex: 1 1 0;
  min-width: 0;
}

/* Style the dropdown toggle button */
.nav-link.select-store {
  padding: 8px 20px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Dropdown menu styling */
.dropdown-menu {
  min-width: 200px;
  padding: 10px 0;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-item img {
  width: 20px;
  margin-right: 10px;
}

.big-placeholder::placeholder {
  font-size: 1.25rem;
}

.qty-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    margin-right: 0;
}

.qty-input {
    width: 48px;
    height: 32px;
    min-width: 48px;
    padding: 4px 4px;
    border: 1px solid #d9dee3;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    box-shadow: none;
    outline: none;
}

/* Remove browser default number spinner */
.qty-input::-webkit-outer-spin-button,
.qty-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.qty-input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.qty-input:focus {
    border-color: #7367f0;
    box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.10);
}

.qty-btn {
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.15s ease;
}

.qty-btn:hover:not(:disabled) {
    background: #f1f2f4;
}

.qty-btn:active:not(:disabled) {
    transform: scale(0.94);
}

.qty-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    pointer-events: none;
}

.digital-pay-row {
  width: 100%;
}

/* Shared label width so Discount / Reference fields line up with Digital Pay dropdown */
.pos-pay-label {
  flex: 0 0 168px;
  width: 168px;
  max-width: 168px;
}

.digital-pay-select,
.pos-discount-field,
.pos-reference-field {
  flex: 1 1 auto;
  min-width: 0;
  width: auto !important;
  max-width: none !important;
}

.digital-pay-select > .btn {
  min-height: 38px;
}

.pos-discount-block {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 8px 0;
  border-radius: 6px;
  background: #f3f4f6;
}

.pos-discount-main {
  flex: 1 1 auto;
  min-width: 0;
}

.pos-discount-value {
  flex: 0 0 125px;
  width: 125px;
  text-align: right;
  font-size: 1.25rem;
  line-height: 1.2;
}

.pos-discount-field {
  font-size: 1.25rem;
  text-align: right;
  background: #fff;
}

/* Hide number spinners on discount fields */
.pos-discount-field::-webkit-outer-spin-button,
.pos-discount-field::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  appearance: none !important;
  display: none !important;
  margin: 0;
}

.pos-discount-field[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}

.pos-amount-input {
  width: 125px !important;
  max-width: 125px !important;
  min-width: 125px !important;
  flex: 0 0 125px;
  box-sizing: border-box;
  display: inline-block;
  font-size: 1.25rem;
  text-align: right;
}

.pos-total-payable-row > td {
  border-bottom: 1px solid #adb5bd !important;
  padding-bottom: 0.85rem !important;
  box-shadow: inset 0 -1px 0 #adb5bd;
}

.pos-cash-received {
  min-height: calc((1.5em + 0.5rem + 2px) * 1.2);
  height: calc((1.5em + 0.5rem + 2px) * 1.2);
  font-size: 1.45rem;
  font-weight: 700;
  border: 2px solid #5a67d8;
  background: #eef2ff;
  box-shadow: 0 0 0 2px rgba(90, 103, 216, 0.12);
}

/* Was 1.25rem → +20% */
.pos-due-change-amount {
  font-size: 1.5rem;
}

.search-input-with-clear {
  padding-right: 2.5rem;
}

.search-clear {
  position: absolute;
  top: 50%;
  right: 0.45rem;
  transform: translateY(-50%);
  z-index: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #495057;
  color: #fff;
  line-height: 1;
}

.search-clear:hover {
  background: #212529;
  color: #fff;
}
</style>

